import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12Zm6 0a1 1 0 0 1 1-1h5.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgArrowCircleRight.displayName = 'ArrowCircleRight';
export default SvgArrowCircleRight;
